export default [
    {
        path: '/(uk/|ru/)?/dumps/statistic-dumps',
        component: () => import('../views/dumps/index'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-dumps',
            title: 'Управление'
        },
        children: [
            {
                path: '',
                name: 'dumpsComplete',
                component: () => import('../views/dumps/tables/complete'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Обработанные'
                },
                children: [
                    {
                        path: '',
                        name: 'completePhotocontrol',
                        component: () => import('../views/dumps/tables/completePhotocontrol'),
                        query: true,
                        props: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-dumps',
                            title: 'Завершение регистрации'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dumps/statistic-dumps/lead/complete',
                        name: 'dumpsCompleteList',
                        component: () => import('../views/dumps/tables/completeTable'),
                        query: true,
                        props: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-dumps',
                            title: 'Завершение регистрации'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dumps/statistic-dumps/lead',
                        name: 'dumpscompleteLead',
                        component: () => import('../views/dumps/tables/completeLead'),
                        query: true,
                        props: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-dumps',
                            title: 'Возврат неактивных'
                        },
                    }, {
                        path: '/(uk/|ru/)?/dumps/statistic-dumps/repeat',
                        name: 'dumpscompleteRepeat',
                        component: () => import('../views/dumps/tables/completeRepeat'),
                        query: true,
                        props: true,
                        meta: {
                            requiresAuth: true,
                            activeSideIcon:'#icon-dumps',
                            title: 'Обзвон'
                        },
                    },
                ]
            }, {
                path: '/(uk/|ru/)?/dumps/statistic-dumps/statistic',
                name: 'dumpsUnComplete',
                component: () => import('../views/dumps/tables/UnComplete'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Статистика'
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/dumps/statistic-dumps/statistic/operator',
        name: 'Operator',
        component: () => import('../views/dumps/tables/Operator'),
        query: true,
        props: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-dumps',
            title: 'Оператор'
        },
    }, {
        path: '',
        name: 'DumpsCalling',
        component: () => import('../views/dumps/calling'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-dumps',
            title: 'Обзвон'
        },
        children: [
            {
                path: '/(uk/|ru/)?/call-dumps/calling/registered',
                name: 'DumpsNew',
                component: () => import('../views/dumps/tables/DumpsNew'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Новые'
                },
            }, {
                path: '/(uk/|ru/)?/call-dumps/calling/registered/work',
                name: 'DumpsInWork',
                component: () => import('../views/dumps/tables/DumpsInWork'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'В работе'
                },
            }, {
                path: '/(uk/|ru/)?/call-dumps/calling/registered/finished',
                name: 'DumpsFinished',
                component: () => import('../views/dumps/tables/DumpsFinished'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Завершенные'
                },
            }, {
                path: '/(uk/|ru/)?/call-dumps/calling/registered/registered',
                name: 'DumpsRegistered',
                component: () => import('../views/dumps/tables/DumpsRegistered'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Зарегистрированные'
                },
            }, {
                path: '/(uk/|ru/)?/call-dumps/calling',
                name: 'DumpsPhotocontrol',
                component: () => import('../views/dumps/tables/DumpsPhotocontrol'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Фотоконтроль'
                },
            }, {
                path: '/(uk/|ru/)?/call-dumps/calling/complete',
                name: 'CallingComplete',
                component: () => import('../views/dumps/tables/CallingComplete'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Завершение регистрации'
                },
            }, {
                path: '/(uk/|ru/)?/call-dumps/calling/repeat',
                name: 'CallingRepeat',
                component: () => import('../views/dumps/tables/CallingRepeat'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Возврат неактивных'
                },
            }, {
                path: '/(uk/|ru/)?/call-dumps/calling/lead',
                name: 'CallingLead',
                component: () => import('../views/dumps/tables/CallingLead'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-dumps',
                    title: 'Подумают'
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/dumps/calling/driver',
        name: 'DumpsDriver',
        component: () => import('../views/dumps/Driver'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-dumps',
            title: 'Водитель'
        },
    },
]
